import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import QuestionOfAsk from '../entities/questionOfAsk'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface QuestionOfAskState extends ListState<QuestionOfAsk> {
    editQuestionOfAsk: QuestionOfAsk;
}
class QuestionOfAskModule extends ListModule<QuestionOfAskState, any, QuestionOfAsk>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<QuestionOfAsk>(),
        loading: false,
        editQuestionOfAsk: new QuestionOfAsk(),
    }
    actions = {
        async getAll(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/QuestionOfAsk/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<QuestionOfAsk>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getallaskreply(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/QuestionOfAsk/GetAllAskReply', { params: payload.data });
            return reponse.data.result
        },
        async create(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            await Ajax.post('/api/services/app/QuestionOfAsk/Create', payload.data);
        },
        async update(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            await Ajax.put('/api/services/app/QuestionOfAsk/Update', payload.data);
        },
        async replayask(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/QuestionOfAsk/ReplayAsk', payload.data);
            return reponse.data
        },
        async delete(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            await Ajax.delete('/api/services/app/QuestionOfAsk/Delete?Id=' + payload.data.id);
        },
        async deletereplayask(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            await Ajax.delete('/api/services/app/QuestionOfAsk/DeleteReplayAsk?Id=' + payload.data.id);
        },
        async auditreplayask(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/QuestionOfAsk/AuditReplayAsk', payload.data);
            return reponse.data
        },
        async auditedQuestionOfAsk(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/QuestionOfAsk/AuditedQuestionOfAsk', payload.data);
            context.state.loading = false;
        },
        async get(context: ActionContext<QuestionOfAskState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/QuestionOfAsk/Get?Id=' + payload.data.id);
            context.state.editQuestionOfAsk = reponse.data.result as QuestionOfAsk
        }
    };
    mutations = {
        setCurrentPage(state: QuestionOfAskState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: QuestionOfAskState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: QuestionOfAskState, questionOfAsk: QuestionOfAsk) {
            state.editQuestionOfAsk = questionOfAsk;
        }
    }
}
const questionOfAskModule = new QuestionOfAskModule();
export default questionOfAskModule;